<div class="terms-container">
  <div class="terms-content">
    <div class="terms-header">
      <img src="https://applisound-images.s3.eu-west-3.amazonaws.com/applisound-bleu.png" alt="Applisound logo">
      <h1>{{ 'TERMS.TITLE' | translate }}</h1>
      <p class="last-updated">{{ 'TERMS.LAST_UPDATED' | translate }}: {{ 'TERMS.UPDATE_DATE' | translate }}</p>
    </div>

    <div class="terms-body">
      <section class="terms-section">
        <h2>{{ 'TERMS.ACCEPTANCE.TITLE' | translate }}</h2>
        <p>{{ 'TERMS.ACCEPTANCE.CONTENT' | translate }}</p>
      </section>

      <section class="terms-section">
        <h2>{{ 'TERMS.SERVICES.TITLE' | translate }}</h2>
        <p>{{ 'TERMS.SERVICES.CONTENT' | translate }}</p>
        <ul>
          <li>{{ 'TERMS.SERVICES.ITEM1' | translate }}</li>
          <li>{{ 'TERMS.SERVICES.ITEM2' | translate }}</li>
          <li>{{ 'TERMS.SERVICES.ITEM3' | translate }}</li>
          <li>{{ 'TERMS.SERVICES.ITEM4' | translate }}</li>
          <li>{{ 'TERMS.SERVICES.ITEM5' | translate }}</li>
        </ul>
      </section>

      <section class="terms-section">
        <h2>{{ 'TERMS.USER_OBLIGATIONS.TITLE' | translate }}</h2>
        <p>{{ 'TERMS.USER_OBLIGATIONS.CONTENT' | translate }}</p>
        <ul>
          <li>{{ 'TERMS.USER_OBLIGATIONS.ITEM1' | translate }}</li>
          <li>{{ 'TERMS.USER_OBLIGATIONS.ITEM2' | translate }}</li>
          <li>{{ 'TERMS.USER_OBLIGATIONS.ITEM3' | translate }}</li>
          <li>{{ 'TERMS.USER_OBLIGATIONS.ITEM4' | translate }}</li>
        </ul>
      </section>

      <section class="terms-section">
        <h2>{{ 'TERMS.INTELLECTUAL_PROPERTY.TITLE' | translate }}</h2>
        <p>{{ 'TERMS.INTELLECTUAL_PROPERTY.CONTENT1' | translate }}</p>
        <p>{{ 'TERMS.INTELLECTUAL_PROPERTY.CONTENT2' | translate }}</p>
        <p>{{ 'TERMS.INTELLECTUAL_PROPERTY.CONTENT3' | translate }}</p>
      </section>

      <section class="terms-section">
        <h2>{{ 'TERMS.PAYMENT.TITLE' | translate }}</h2>
        <p>{{ 'TERMS.PAYMENT.CONTENT1' | translate }}</p>
        <p>{{ 'TERMS.PAYMENT.CONTENT2' | translate }}</p>
        <p>{{ 'TERMS.PAYMENT.CONTENT3' | translate }}</p>
      </section>

      <section class="terms-section">
        <h2>{{ 'TERMS.LIABILITY.TITLE' | translate }}</h2>
        <p>{{ 'TERMS.LIABILITY.CONTENT1' | translate }}</p>
        <p>{{ 'TERMS.LIABILITY.CONTENT2' | translate }}</p>
      </section>

      <section class="terms-section">
        <h2>{{ 'TERMS.TERMINATION.TITLE' | translate }}</h2>
        <p>{{ 'TERMS.TERMINATION.CONTENT' | translate }}</p>
      </section>

      <section class="terms-section">
        <h2>{{ 'TERMS.MODIFICATIONS.TITLE' | translate }}</h2>
        <p>{{ 'TERMS.MODIFICATIONS.CONTENT' | translate }}</p>
      </section>

      <section class="terms-section">
        <h2>{{ 'TERMS.GOVERNING_LAW.TITLE' | translate }}</h2>
        <p>{{ 'TERMS.GOVERNING_LAW.CONTENT' | translate }}</p>
      </section>

      <section class="terms-section">
        <h2>{{ 'TERMS.CONTACT.TITLE' | translate }}</h2>
        <p>{{ 'TERMS.CONTACT.CONTENT' | translate }}</p>
        <div class="contact-info">
          <p><strong>{{ 'TERMS.CONTACT.COMPANY' | translate }}</strong></p>
          <p>{{ 'TERMS.CONTACT.EMAIL' | translate }}: <a href="mailto:contact@applisound.com">contact&#64;applisound.com</a></p>
          <p>{{ 'TERMS.CONTACT.PHONE' | translate }}: +33 6 28 79 41 00</p>
        </div>
      </section>
    </div>
  </div>
</div>